import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './modal.js'

module.exports = React.createClass({
    abort: function() {
        this.props.promise.reject();
        HC_CloseModal();
    },
    confirm: function() {
        this.props.promise.resolve();
        if (!this.props.ignoreCloseOnConfirm)
            HC_CloseModal();
    },
    componentDidMount: function() {
        return ReactDOM.findDOMNode(this.refs.confirm).focus();
    },
    render: function() {

        var abortButton;
        if (this.props.abortLabel) {
            abortButton = (
                <button role='abort' className='hc-button-cancel hc-dialog-cancel hc-f3' style={{marginLeft:"0.5rem" }}
                        onClick={this.abort}>
                    {this.props.abortLabel}
                </button>
            );
        }

        return (
            <Modal data-style={this.props['data-style']}>
                <div className='modal-body' style={{marginTop: "2.5rem"}}>
                    <div className="hc-f2"
                         style={{textAlign:"center", wordWrap:"break-word"}}>{this.props.message}</div>
                    <div className='text-right' style={{marginTop: "1rem", marginBottom: "2rem", textAlign:"center"}}>
                        <button
                            role='confirm'
                            type='button'
                            className='hc-button'
                            ref='confirm'
                            onClick={this.confirm}>
                            {this.props.confirmLabel}
                        </button>
                        {abortButton}
                    </div>
                </div>
            </Modal>
        );
    }
});



// WEBPACK FOOTER //
// ./confirm.js